import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

export const IDS = {
    NOT_INTERESTED: 10010,
    ALREADY_WORKING: 10020,
    SENT_IN_ERROR: 10030,
    NOT_SURE: 10040,
};

class LuDeclineInvitationReasonAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Lu-Decline-Invitation-Reason';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'users/invitations/decline-reasons';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at'
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'id',
            'slug',
            'title',
            'description',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return [];
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
        };
    }
}

export default LuDeclineInvitationReasonAppResource;
